import { Form } from '@unform/web';
import styled from 'styled-components';

export const ContainerEyer = styled.div`
  display: flex;
  gap: 1.5rem;

  align-items: center;
  justify-content: center;

  > div:first-child {
    flex: 1;
  }
`;

export const FormWrapper = styled(Form)`
  > div:not(:last-child) {
    margin-bottom: 1rem;
  }

  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0;
  }
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;
